import { useQueryClient } from "@tanstack/react-query";

import { PhysicalQuantity, getRanaApiV1 } from "@nens/rana/api-v1";

import { queryDirectly } from "./hooks/query-directly";

// STAT

export type StylingOptions = {
  [key in PhysicalQuantity]: { style_id: string; min_max: [number, number] | null };
};

const getStylingOptionsQuery = (physicalQuantity: PhysicalQuantity) => {
  return getRanaApiV1().getQueryOptions<StylingOptions>({
    queryKey: ["physical-quantity-style-id", physicalQuantity],
    queryFn: async () => {
      return getRanaApiV1().StylesApi.listPhysicalQuantityStyles({}) as Promise<StylingOptions>;
    },
  });
};

export const useSetStylingOptionsQuery = (physicalQuantity: PhysicalQuantity) => {
  const queryClient = useQueryClient();
  return (styling: StylingOptions) => {
    queryClient.setQueryData(getStylingOptionsQuery(physicalQuantity).queryKey, styling);
  };
};

export const useStylingOptionsQueryDirectly = () => {
  const queryClient = useQueryClient();
  return (physicalQuantity: PhysicalQuantity) =>
    queryDirectly(queryClient, getStylingOptionsQuery(physicalQuantity));
};
